import { render, staticRenderFns } from "./GlobalUpload.vue?vue&type=template&id=38877127&"
import script from "./GlobalUpload.vue?vue&type=script&lang=js&"
export * from "./GlobalUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports